import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/homepage/EbookDownload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/homepage/HeroYoutube.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/homepage/Welcome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/before-after/9.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/campaign/longhairs.jpg");
